/**
 * «Создать техкарту» — вход в мастер создания (ADR-071 D1, 8 шагов founder).
 *
 * История: кнопка появилась после founder UAT 19.08 (ручка была, входа не
 * было); с ADR-071 простая форма выросла в мастер — название → культуры-чипы →
 * предшественники → урожайность → вариант плана → «подходит N га · M полей» →
 * создать и наполнить. Сам мастер живёт в `CreateCardWizard.tsx`.
 */
import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { useCan } from '@/lib/auth/usePermissions';
import { CreateCardWizard } from './CreateCardWizard';

export function CreateCardButton({
  seasonId,
  seasonYear,
  emptyState = false,
  onCreated,
}: {
  seasonId: string | null;
  seasonYear: number;
  emptyState?: boolean;
  onCreated: (cardId: string) => void;
}) {
  const canCreate = useCan('tech_cards', 'c');
  const [open, setOpen] = useState(false);

  if (!canCreate) {
    return emptyState ? (
      <p className="mt-3 text-sm text-muted-foreground">
        Заводить техкарты может пользователь с правом на них — обратитесь к экономисту или
        администратору.
      </p>
    ) : null;
  }

  return (
    <>
      <Button
        type="button"
        size="sm"
        variant={emptyState ? 'default' : 'outline'}
        disabled={!seasonId}
        onClick={() => setOpen(true)}
      >
        {emptyState ? 'Создать техкарту' : '+ Новая техкарта'}
      </Button>
      {open && seasonId && (
        <CreateCardWizard
          seasonId={seasonId}
          seasonYear={seasonYear}
          onClose={() => setOpen(false)}
          onCreated={(id) => {
            setOpen(false);
            onCreated(id);
          }}
        />
      )}
    </>
  );
}
